import { orderBy } from 'lodash';
import React from 'react';
import { allMenuItem } from '../components/CommonTableColumns/index';
import MenuItem from '../components/MenuItem/MenuItem';
import APIClient from '../services/APIClient';

export class Customer {
  getAll = () => APIClient.get('/customers');

  toSelectOptions = (data) => {
    const mapped = data.map((customer) => ({ value: customer.customerId, label: customer.customerName }));

    return orderBy(mapped, [(item) => item.label.toLowerCase()]);
  };

  toSelect = (data) => {
    const customersOptions = [allMenuItem];

    data.forEach(({ value, label }) => {
      customersOptions.push(
        <MenuItem key={value} value={value} title={label}>
          {label}
        </MenuItem>,
      );
    });

    return customersOptions;
  };
}

export default new Customer();
